import React, { useRef, useContext } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import Checkbox from "@mui/material/Checkbox";
import Tools from "./JNSTools";
import FormControlLabel from "@mui/material/FormControlLabel";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";
import SquareIcon from "@mui/icons-material/Square";
import IconButton from "@mui/material/IconButton";
import HelpCenterIcon from "@mui/icons-material/HelpCenter";
import { CredsContext, HelpModeContext } from "./Contexts";
import "./styles/ChangeLog.css";

function ChangeLogHeader(props) {
  const creds = useContext(CredsContext).creds;
  const projectObject = JSON.parse(sessionStorage.getItem("projectObject"));
  const viewType = "grid"; // or narrative
  let settings;
  const settingsRaw = localStorage.getItem("oadaSettings");
  if (settingsRaw) {
    settings = JSON.parse(settingsRaw);
  }

  const checkboxSettingsTasks = useRef(
    typeof settings.changeLogCheckboxSettingsTasks == "string"
      ? settings.changeLogCheckboxSettingsTasks == "true"
        ? true
        : false
      : settings.changeLogCheckboxSettingsTasks,
  );
  const checkboxSettingsIssues = useRef(
    typeof settings.changeLogCheckboxSettingsIssues == "string"
      ? settings.changeLogCheckboxSettingsIssues == "true"
        ? true
        : false
      : settings.changeLogCheckboxSettingsIssues,
  );
  const checkboxSettingsReqs = useRef(
    typeof settings.changeLogCheckboxSettingsReqs == "string"
      ? settings.changeLogCheckboxSettingsReqs == "true"
        ? true
        : false
      : settings.changeLogCheckboxSettingsReqs,
  );
  const helpMode = useContext(HelpModeContext).mode;
  const setHelpMode = useContext(HelpModeContext).setMode;

  const handleHelpClick = () => {
    setHelpMode(!helpMode);
  };

  const handleCheckboxChange = (event) => {
    switch (event.target.id) {
      case "chkTasks":
        checkboxSettingsTasks.current = !checkboxSettingsTasks.current;
        break;
      case "chkIssues":
        checkboxSettingsIssues.current = !checkboxSettingsIssues.current;
        break;
      case "chkReqs":
        checkboxSettingsReqs.current = !checkboxSettingsReqs.current;
        break;
    }
    settings.changeLogCheckboxSettingsTasks = checkboxSettingsTasks.current;
    settings.changeLogCheckboxSettingsIssues = checkboxSettingsIssues.current;
    settings.changeLogCheckboxSettingsReqs = checkboxSettingsReqs.current;

    localStorage.setItem("oadaSettings", JSON.stringify(settings));
    Tools.writeSettings(creds, projectObject.id);

    props.handleCheckboxChange();
  };
  return (
    <Box
      width="100%"
      height="2.5em"
      sx={{ backgroundColor: "silver", padding: "0px 5px", fontSize: "16px" }}
    >
      <Table>
        <TableBody>
          <TableRow>
            <TableCell sx={{ padding: "0px" }}>
              <span
                style={{
                  fontWeight: "bold",
                  fontFamily: "Roboto-Light",
                  fontSize: "large",
                  backgroundColor: "#643f69",
                  padding: "4px 6px",
                  color: "white",
                  borderRadius: "12px 0px 0px 12px",
                }}
              >
                PROJECT:
              </span>
              <span
                style={{
                  fontSize: "large",
                  fontFamily: "Roboto-Light",
                  backgroundColor: "#643f69",
                  padding: "4px 6px",
                  color: "white",
                  borderRadius: "0px 12px 12px 0px",
                }}
              >
                {props.projectname.toUpperCase()}
              </span>
            </TableCell>
            <TableCell sx={{ padding: "0px" }}>
              <Typography>
                Showing changes made in the last {props.daysPast} days
              </Typography>
            </TableCell>
            <TableCell
              sx={{
                padding: "2px",
                textAlign: "center",
              }}
            >
              <Box className={props.className}>
                <FormControlLabel
                  data-entitytype="Task"
                  className="typeSelection"
                  sx={{ display: "table-cell" }}
                  control={
                    <Checkbox
                      data-entitytype="Task"
                      className="typeSelection"
                      id="chkTasks"
                      onChange={handleCheckboxChange}
                      size="small"
                      checked={checkboxSettingsTasks.current || false}
                      icon={
                        <SquareIcon
                          sx={{
                            color: "white",
                          }}
                        />
                      }
                    />
                  }
                  label="Tasks&nbsp;&nbsp;&nbsp;"
                />
                <FormControlLabel
                  data-entitytype="Issue"
                  className="typeSelection"
                  sx={{ display: "table-cell" }}
                  control={
                    <Checkbox
                      data-entitytype="Issue"
                      className="typeSelection"
                      id="chkIssues"
                      onChange={handleCheckboxChange}
                      size="small"
                      checked={checkboxSettingsIssues.current}
                      icon={
                        <SquareIcon
                          sx={{
                            color: "white",
                          }}
                        />
                      }
                    />
                  }
                  label="RAID items&nbsp;&nbsp;&nbsp;"
                />
                <FormControlLabel
                  data-entitytype="Requirement"
                  className="typeSelection"
                  sx={{ display: "table-cell" }}
                  control={
                    <Checkbox
                      data-entitytype="Requirement"
                      className="typeSelection"
                      id="chkReqs"
                      onChange={handleCheckboxChange}
                      size="small"
                      checked={checkboxSettingsReqs.current}
                      icon={
                        <SquareIcon
                          sx={{
                            color: "white",
                          }}
                        />
                      }
                    />
                  }
                  label="Requirements"
                />
              </Box>
            </TableCell>
            {viewType == "narrative" ? (
              <TableCell sx={{ padding: "2px", textAlign: "left" }}>
                <span style={{ fontWeight: "bold" }}>
                  Group by:&nbsp;&nbsp;
                </span>
                Date
                <Switch
                  color="default"
                  onChange={props.handleGroupByChange}
                  checked={props.groupBy == "name"}
                />
                Name
              </TableCell>
            ) : null}
            <TableCell
              sx={{
                padding: "0px 0px 0px 20px",
                backgroundColor: "#643f69",
                borderRadius: "15px",
              }}
            >
              <IconButton
                id="helpButton"
                onClick={handleHelpClick}
                sx={{ padding: "0px" }}
              >
                <HelpCenterIcon
                  fontSize="large"
                  sx={{
                    paddingRight: "0px",
                    color: helpMode ? "skyblue" : "white",
                  }}
                />
              </IconButton>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
}

export default ChangeLogHeader;

ChangeLogHeader.propTypes = {
  projectname: PropTypes.string,
  handleGroupByChange: PropTypes.func,
  handleCheckboxChange: PropTypes.func,
  groupBy: PropTypes.string,
  className: PropTypes.string,
  daysPast: PropTypes.number,
};
